import { useState } from "react";
import Input from "../../../shared/Input";
import Select from "../../../shared/Select";
import Toggle from "../../../shared/Toggle";
import OrgCreateForm from "../../Organizations/CreateForm";
import DriverComplianceSection from "../DriverComplianceSection";
import { DRIVER_FORM_SIZE } from "../../../constants/driver-profile";

const DriverCreateForm = ({
  form = {},
  updateForm,
  errors = {},
  driverOrg,
  setDriverOrg,
  clearForm,
  hideOrg,
  orgOptions,
  user,
}) => {
  const [createOrg, setCreateOrg] = useState(false);

  function handleOrgClick() {
    setCreateOrg(!createOrg);
    clearForm("organization");
  }

  function setOrg(e) {
    updateForm({
      id: "organization",
      value: { ...form.organization, [e.id]: e.value },
    });
  }

  return (
    <div className="space-y-6">
      <section className="space-y-4">
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-neutral-700">
            Driver Information
          </h3>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Input
            id="firstName"
            label="First Name"
            placeholder="First Name"
            onChange={updateForm}
            value={form.firstName}
            error={errors.firstName}
            size={DRIVER_FORM_SIZE}
          />
          <Input
            id="lastName"
            label="Last Name"
            placeholder="Last Name"
            value={form.lastName}
            onChange={updateForm}
            size={DRIVER_FORM_SIZE}
          />
          <Input
            id="email"
            label="Email"
            placeholder="Email"
            onChange={updateForm}
            value={form.email}
            size={DRIVER_FORM_SIZE}
          />
          <Input
            id="phone"
            label="Phone"
            value={form.phone}
            placeholder="Phone"
            onChange={updateForm}
            type="tel"
            size={DRIVER_FORM_SIZE}
          />
        </div>
      </section>

      <DriverComplianceSection form={form} updateForm={updateForm} />

      {hideOrg ? null : (
        <section className="space-y-3 rounded-lg border border-gray-200 p-4">
          <div className="flex items-center">
            <h3 className="mr-3 block text-sm font-semibold uppercase tracking-wide text-neutral-700">
              Driver Organization
            </h3>
            <Toggle
              size={DRIVER_FORM_SIZE}
              checked={driverOrg}
              onChange={() => {
                setDriverOrg(!driverOrg);
                setCreateOrg(false);
                clearForm("organization");
              }}
            />
          </div>
          {driverOrg && (
            <div className="space-y-1">
              {createOrg ? (
                <OrgCreateForm
                  user={user}
                  hideEmployees
                  form={{ form, updateForm: setOrg, errors }}
                />
              ) : (
                <Select
                  value={form.organization?.name}
                  id="organization"
                  label="Organization"
                  placeholder="Driver Organization"
                  onChange={updateForm}
                  options={orgOptions}
                  size={DRIVER_FORM_SIZE}
                />
              )}
              <div>
                <span
                  className="cursor-pointer text-sm text-gray-600 hover:underline"
                  onClick={handleOrgClick}
                >
                  {!createOrg
                    ? "Create new organization"
                    : "Select an organization"}
                </span>
              </div>
            </div>
          )}
        </section>
      )}
    </div>
  );
};

export default DriverCreateForm;
